import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './components/App';
import ErrorBoundary from './components/ErrorBoundary';
import { registerGlobalErrorHandlers } from './utils/globalErrorHandlers';

registerGlobalErrorHandlers();

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <ErrorBoundary area="application" variant="global">
      <App />
    </ErrorBoundary>
  </React.StrictMode>,
);
